import { Routes, Route, BrowserRouter } from 'react-router-dom';
import { CurrentUserContext } from '../../contexts/CurrentUserContext';
import React, { useState, useEffect } from 'react';
import api from '../../utils/Api';
import './App.css';

import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import AboutUs from '../AboutUs/AboutUs';
import TrainersCarousel from '../TrainersCarousel/TrainersCarousel';
import LessonsList from '../Lessons/LessonsList';
import FirstLessonRequirements from '../FirstLessonRequirements/FirstLessonRequirements';
import ProductsList from '../Products/ProductsList';
import Promotions from '../Promotions/Promotions';
import SocialLinks from '../SocialLinks/SocialLinks';
import PhotoSlider from '../PhotoSlider/PhotoSlider';
import VideoPlay from '../VideoPlay/VideoPlay';
import ActionNewYear from '../ActionNewYear/ActionNewYear'

function App() {
  const [currentUser, setCurrentUser] = useState({});

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://w1603385.yclients.com/widgetJS';
    script.async = true;
    script.charset = 'UTF-8';
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);


  return (
    <div>
      <BrowserRouter>
        <CurrentUserContext.Provider value={currentUser}>
          <Header />

          <Routes>
            <Route path="/" element={<><VideoPlay /><AboutUs /><TrainersCarousel /><LessonsList id="lesson-types" /><FirstLessonRequirements /><PhotoSlider/><ProductsList /><Promotions /><div id="ycwidget"></div></>} />
            <Route path="/video" element={<VideoPlay />} />
            <Route path='/action' element={<ActionNewYear/>}/>
            <Route path="/about" element={<AboutUs />} />
            <Route path="/trainers" element={<TrainersCarousel />} />
            <Route path="/lessons" element={<LessonsList id="lesson-types" />} />
            <Route path="/products" element={<ProductsList />} />
            <Route path="/promotions" element={<Promotions />} />
            {/* <Route path="/social" element={<SocialLinks />} /> */}
            <Route path="/first" element={<FirstLessonRequirements />} />
            <Route path="/photo" element={<PhotoSlider />} />
            {/* Добавьте маршруты для остальных страниц (blog, contacts и т.д.) */}
          </Routes>
         
        </CurrentUserContext.Provider>
      </BrowserRouter>
      <SocialLinks />  
      <Footer />
      
    </div>
  );
}

export default App;
